import * as moment from 'moment';
import { Moment } from 'moment';
import { Carrier } from '../../user-dashboard/shared/carrier.model';
import {UserType} from './user-type.enum';

export class Trailer {

  public trailerId: string;
  public status: string;
  public reportedAt: Moment;
  public reportedBy: string;
  public carrier: Carrier;
  public reportedByRole: UserType;

  static fromDto(t: any): Trailer {
    const trailer = new Trailer();

    if (!t) {
      return null;
    }

    trailer.trailerId  = t.trailer_id;
    trailer.status     = t.status;
    trailer.reportedAt = t.reported_at ? moment(t.reported_at) : null;
    trailer.reportedBy = t.reported_by;
    trailer.carrier    = Carrier.fromDto(t.carrier);
    trailer.reportedByRole = t.reported_by_role;

    return trailer;
  }
}
